import { createSlice } from "@reduxjs/toolkit";
import { getServerDate } from "root/utils/date";

import { costPriceTabs, tableTabs } from "root/pages/cost_price/components/utils";

export const defaultFilterParams = {
  brandIds: [],
  productIds: [],
  barcodeIds: [],
  search: "",
  date_range: [null, null],
};

export const getFiltersFromParams = params => {
  const result = {};

  for (const key in params) {
    const value = params[key];

    if (value === "" || value == null || (Array.isArray(value) && value.length === 0)) {
      result[key] = "";
      continue;
    }

    if (key === "search") {
      result[key] = value;
    } else if (key === "brandIds") {
      result["brand_id__in"] = value.map(item => item.brand_id).join(",");
    } else if (key === "productIds") {
      result["product_id__in"] = value.map(item => item.product_id).join(",");
    } else if (key === "barcodeIds") {
      result["barcode__in"] = value.map(item => item.barcode).join(",");
    } else if (key === "date_range") {
      result[key] = value;
      if (value?.[0]) result["date_from"] = getServerDate(value[0]);
      if (value?.[1]) result["date_to"] = getServerDate(value[1]);
    } else {
      result[key] = value;
    }
  }
  console.log("{PARAMS}", result);
  return result;
};

const initialState = {
  changes: [],
  data: [],
  filterParams: {
    ...defaultFilterParams,
  },
  selectedMarketplaces: ["wb"],
  currentTabId: costPriceTabs[0].id,
  currentTableTabId: tableTabs[0].id,
  defaultDateRange: [null, null],
};

const costPrice = createSlice({
  name: "costPrice",
  initialState,
  reducers: {
    addChanges(state, { payload }) {
      const { mp_item_id, cabinet_id, ...rest } = payload;
      console.log("payload", payload);

      const alreadyChanged = state.changes.find(
        item => item.mp_item_id === mp_item_id && item.cabinet_id === cabinet_id
      );
      if (alreadyChanged)
        state.changes = state.changes.map(item =>
          item.mp_item_id === mp_item_id && item.cabinet_id === cabinet_id
            ? { ...item, ...payload }
            : item
        );
      else state.changes = [...state.changes, payload];
    },
    setFilterParam(state, { payload: { name, value } }) {
      state.filterParams[name] = value;
    },
    updateDefaultDateRange(state, { payload }) {
      state.defaultDateRange = payload;
    },
    resetFilterParams(state) {
      state.filterParams = { ...defaultFilterParams, date_range: state.defaultDateRange };
    },
    setCurrentTab(state, { payload }) {
      const previousTabId = state.currentTabId;
      state.currentTabId = payload;
      state.changes = [];

      if (previousTabId !== payload) {
        if (payload === "by_deliveries") {
          state.selectedMarketplaces =
            state.selectedMarketplaces.length > 0 ? [state.selectedMarketplaces[0]] : ["wb"];
        } else if (payload === "by_default") {
          state.selectedMarketplaces = ["wb"];
        }
      }
    },
    setCurrentTableTab(state, { payload }) {
      state.currentTableTabId = payload;
      state.changes = [];
    },
    setSelectedMarketplaces(state, { payload }) {
      if (!payload || payload.length === 0) {
        state.selectedMarketplaces = ["wb"];
      } else {
        state.selectedMarketplaces = payload;
      }
    },
  },
});

export default costPrice.reducer;

const { ...rest } = costPrice.actions;
export const costPriceActions = { ...rest };
